import { createContext } from 'react';

const SurveyResultContext = createContext({
  answersMatchedAudiences: [],
  answersMatchedTags: [],
  overallScoreComponentId: null,
  generalScoreComponentsIds: [],
  overallComponentLabel: null,
  scoreComponentsLabels: [],
  handlePdfContent: () => {},
  excludedTopicId: [],
});

export default SurveyResultContext;
